import { useCallback, useState } from 'react';

export const isBlank = value => value == null || !String(value).trim();

// Reuse submit validators, exposing only fields the user has left or submitted.
export default function useFieldValidation(form, validate) {
  const [submittedErrors, setSubmittedErrors] = useState({});
  const [touched, setTouched] = useState({});
  const currentErrors = validate(form, true);
  const errors = { ...submittedErrors };
  Object.keys(touched).forEach(field => { errors[field] = currentErrors[field]; });

  function touchField(field) {
    setTouched(current => ({ ...current, [field]: true }));
  }

  const setErrors = useCallback(update => {
    setSubmittedErrors(current => {
      const next = typeof update === 'function' ? update(current) : update;
      return next;
    });
    if (typeof update !== 'function') {
      setTouched(Object.fromEntries(Object.keys(update).filter(field => field !== 'form').map(field => [field, true])));
    }
  }, []);

  return { errors, setErrors, touchField };
}
